import { Button, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { MessageKey, useI18n } from '../i18n';
import { ActionCard } from './ActionCard';
import { TranslatedText } from './TranslatedText';

interface InfoPageTemplateProps {
  eyebrow: MessageKey;
  title: MessageKey;
  subtitle: MessageKey;
  summary: MessageKey;
  bullets: [MessageKey, MessageKey, MessageKey];
  primaryTo: string;
  primaryLabel: MessageKey;
  secondaryTo: string;
  secondaryLabel: MessageKey;
}

const PageStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2.5),
}));

const BulletList = styled('ul')(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(2.5),
  display: 'grid',
  gap: theme.spacing(1),
}));

export function InfoPageTemplate({
  eyebrow,
  title,
  subtitle,
  summary,
  bullets,
  primaryTo,
  primaryLabel,
  secondaryTo,
  secondaryLabel,
}: InfoPageTemplateProps) {
  const { t } = useI18n();

  return (
    <PageStack>
      <TranslatedText
        messageKey={eyebrow}
        variant="overline"
        color="primary.light"
      />
      <ActionCard title={title} subtitle={subtitle}>
        <TranslatedText messageKey={summary} variant="body1" />
        <BulletList>
          {bullets.map((bullet) => (
            <Typography key={bullet} component="li" variant="body2">
              {t(bullet)}
            </Typography>
          ))}
        </BulletList>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <Button component={RouterLink} to={primaryTo} variant="contained">
            {t(primaryLabel)}
          </Button>
          <Button component={RouterLink} to={secondaryTo} variant="outlined">
            {t(secondaryLabel)}
          </Button>
        </Stack>
      </ActionCard>
    </PageStack>
  );
}
